
import { Component, Inject, Vue } from 'vue-property-decorator';
import GeneralScaffold from '@/components/GeneralScaffold.vue';
import PagedDataTable from '@/components/PagedDataTable.vue';
import NavigationItemRepository from '@/repositories/sidebar/NavigationItemRepository';

@Component({
    components: { GeneralScaffold, PagedDataTable },
})
export default class NavigationListScreen extends Vue {
    @Inject()
    private readonly navigationItemRepository!: NavigationItemRepository;

    public get headers(): any[] {
        return [
            {
                text: this.$t('general.actions'),
                value: 'action',
                sortable: false,
            },
            {
                text: this.$t('crud.navigationItem.defaultName'),
                align: 'left',
                value: 'defaultName',
                sortable: true,
            },
            {
                text: this.$t('crud.navigationItem.order'),
                value: 'order',
                sortable: true,
            },
        ];
    }
}
